import config from 'SRC/config/config.yaml'

export const adsSortTypes = config.filters.adsSortTypes
